import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_rule",
  ref: "addInventoryRuleModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_rule_header"
}
const _hoisted_5 = {
  key: 0,
  class: "fw-bolder"
}
const _hoisted_6 = {
  key: 1,
  class: "fw-bolder"
}
const _hoisted_7 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_rule_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_rule_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_rule_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_11 = { class: "row mb-7" }
const _hoisted_12 = { class: "col-md-12 form-group" }
const _hoisted_13 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_14 = { class: "row mb-7" }
const _hoisted_15 = { class: "col-md-6 form-group" }
const _hoisted_16 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_17 = { class: "col-md-6 form-group" }
const _hoisted_18 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_19 = { class: "row mb-7" }
const _hoisted_20 = { class: "col-md-6 form-group" }
const _hoisted_21 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_22 = { class: "col-md-6 form-group" }
const _hoisted_23 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_24 = {
  key: 0,
  class: "row mb-7"
}
const _hoisted_25 = { class: "col-md-6 form-group" }
const _hoisted_26 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_27 = { class: "modal-footer flex-center" }
const _hoisted_28 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_29 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_30 = { class: "indicator-label" }
const _hoisted_31 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_32 = { class: "indicator-progress" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.id == 0)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_ctx.$t("merchants.addInventoryRules")), 1))
            : (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_ctx.$t("merchants.editInventoryRules")), 1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("merchants.salesChannel")), 1),
                    _createVNode(_component_el_form_item, { prop: "channel_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.channel_id,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.channel_id) = $event)),
                          filterable: "",
                          clearable: "",
                          placeholder: _ctx.$t('common.plsEnter')
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chanelOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("merchants.brand")), 1),
                    _createVNode(_component_el_form_item, { prop: "brand_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.brand_id,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.brand_id) = $event)),
                          filterable: "",
                          clearable: "",
                          remote: "",
                          "reserve-keyword": "",
                          placeholder: _ctx.$t('common.plsEnter'),
                          "remote-method": _ctx.searchBrandItems,
                          loading: _ctx.brandLoading
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brands, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("merchants.category")), 1),
                    _createVNode(_component_el_form_item, { prop: "category_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "category_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_cascader, {
                              options: _ctx.tableArr,
                              "show-all-levels": false,
                              props: _ctx.propData,
                              clearable: "",
                              filterable: "",
                              lazy: "",
                              modelValue: _ctx.formData.category_id,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.category_id) = $event)),
                              onChange: _ctx.parentChange,
                              placeholder: _ctx.$t('common.plsSelect')
                            }, null, 8, ["options", "props", "modelValue", "onChange", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("merchants.key")), 1),
                    _createVNode(_component_el_form_item, { prop: "key_type" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.key_type,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.key_type) = $event)),
                          clearable: "",
                          placeholder: _ctx.$t('common.plsSelect'),
                          style: {"width":"100%"},
                          onChange: _ctx.keyTypeChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.inventory_keys, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("merchants.value")), 1),
                    _createVNode(_component_el_form_item, { prop: "key_value" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.key_value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.key_value) = $event)),
                          modelModifiers: { number: true },
                          type: "number",
                          placeholder: _ctx.$t('common.plsEnter')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_ctx.isShowDuration)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("merchants.duration")), 1),
                        _createVNode(_component_el_form_item, { prop: "duration" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.formData.duration,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.duration) = $event)),
                              clearable: "",
                              placeholder: _ctx.$t('common.plsSelect'),
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.duration, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-light me-3",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_28, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("common.discard")), 1)
              ]),
              _createElementVNode("button", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("common.submit")), 1)
                ]),
                _createElementVNode("span", _hoisted_32, [
                  _createTextVNode(_toDisplayString(_ctx.$t("common.pleaseWait")) + " ", 1),
                  _hoisted_33
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}